import React from 'react'

import DataAccessRequestsTable from './DataAccessRequestsTable'

export const DataAccessRequestsTab = () => {
  return <DataAccessRequestsTable />
}
